import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import AuthFooter from "../../layout/AuthLayout/Footer";
import ArrowTickLeft from "../../../media/images/icons/arrow-tick-left";

export default function CoursesPage() {
  const theme = useTheme();

  return (
    <>
      <MobileHeader>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: "secondary.main",
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            کارن ترابر نت
          </Typography>
          <ArrowTickLeft color={theme.palette.textColor.main} size={14} />
          <Typography
            sx={{
              color: "secondary.main",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            آموزش ویدیویی
          </Typography>
        </Box>
      </MobileHeader>

      <Box
        sx={{
          // minWidth: "480px",
          maxWidth: "600px",
          width: {
            xs: "100%",
          },
          // border: "1px solid gray",
          marginX: "auto",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          paddingY: "20px",
          gap: "12px",
          overflowY: "auto",
        }}
      >
        <Outlet />
        <AuthFooter />
      </Box>
    </>
  );
}
